import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.945 8.049c.013.178.013.355.013.533 0 5.419-4.125 11.663-11.663 11.663-2.322 0-4.48-.673-6.295-1.84.33.038.647.05.99.05 1.916 0 3.68-.647 5.089-1.751-1.802-.038-3.313-1.218-3.832-2.843.253.038.507.064.774.064.368 0 .735-.051 1.078-.14-1.878-.381-3.286-2.031-3.286-4.023v-.051c.545.305 1.179.495 1.853.521-1.105-.737-1.828-1.993-1.828-3.414 0-.762.203-1.46.558-2.069 2.018 2.488 5.051 4.112 8.452 4.29-.063-.305-.101-.622-.101-.94C11.747 5.84 13.574 4 15.846 4c1.18 0 2.246.495 2.994 1.295.927-.178 1.815-.52 2.603-.99-.305.952-.952 1.751-1.802 2.259.824-.089 1.624-.318 2.359-.634-.557.812-1.256 1.535-2.055 2.119z",
    fill: "currentColor"
  }));
});